export const CREATOR_MISCELLANEOUS_DATA_APIS = {
    get: "users/miscellaneous/data",
};
